import { DisplayIconProps } from "./types";

function DisplayIcon(props: DisplayIconProps) {
  return (
    <img
      className="displayIcon showDefault"
      src={props.iconUrl}
      alt=""
      onLoad={e => e.currentTarget.classList.remove("showDefault")}
    />
  );
}

export default DisplayIcon;
